var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    /**
     * Will be called from the document everytime it gets cleared.
     * Modules should clear its document related data.
     */
    AppModule.prototype.clearDocumentData = function () { };
    /**
     * Will be called from the document everytime after it gets loaded.
     * If the promise is rejected with a core.io.AbortError the whole document load process will be aborted.
     */
    AppModule.prototype.loadDocumentData = function (pContext, pData) {
        return (Promise.resolve());
    };
    /**
     * Will be called from the document everytime it gets saved.
     * If the promise is rejected with a core.io.AbortError the whole document save process will be aborted.
     */
    AppModule.prototype.saveDocumentData = function (pContext, pOptions) {
        return (Promise.resolve(null));
    };
    return AppModule;
}());
export { AppModule };
